<div class="row">
    <h2 class="page-title">MSISDN Range</h2>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a routerlink="."
                    href="/">Home</a>
            </li>
            <li aria-current="page"
                class="breadcrumb-item active">MSISDN Range</li>
        </ol>
    </nav>
</div>
<div class="grid-margin stretch-card">
    <div class="card">
        <div
            class="card-body">
            <div class="clearfix mb-2">

                <div class="float-start">

                  <div class="input-group search-component">
                    <input
                    type="text"
                    class="form-control"
                    placeholder="Search"
                    aria-label="Search"
                    [(ngModel)]="element.searchKey"
                    name="element"
                  />
                    <button type="button" (click)="clearSearch()" class="btn btn-outline-secondary btn-icon">
                      <i class="feather icon-x"></i>
                    </button>
                    <button appBusy type="button"  (click)="searchKey()" class="btn btn-outline-primary btn-icon-text">
                      <i class="feather icon-search btn-icon-prepend"></i> Search </button>
                  </div>

                </div>
                <div class="float-end"><button *ngIf="masterService.checkFeatureBoolean('MASTER.MSISDN.CREATE')" (click)="addMsisdnRange()" 
                                               type="button"
                                               class="btn btn-primary btn-icon-text">
                  <i class="feather icon-plus btn-icon"></i>
                  Add MSISDN Range
                </button></div><br>
            </div>

            <div class="table-responsive">
                <table
                    class="table table-hover">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>MSISDN Range Name
                            </th>
                            <th>Start Number
                            </th>
                            <th>End Number
                            </th>
                            <th>Telecom Service Provider
                            </th>
                            <th>Finance Service Provider
                            </th>
                            <th>Date Created
                            </th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let msisdnRange of msisdnRangeList ; let row = index">
                            <td>{{ row + 1 }}</td>
                            <td>{{ msisdnRange.rangeName }}</td>
                            <td>{{ msisdnRange.startNumber }} </td>
                            <td>{{msisdnRange.endNumber }} </td>
                            <td>{{ msisdnRange.serviceProvider.name }}</td>
                            <td>{{ msisdnRange.financialInstitution.name }}</td>
                            <td>{{ msisdnRange.createdDate | date: 'dd-MM-yyyy HH:mm' }}</td>
                            <td> <button *ngIf="masterService.checkFeatureBoolean('MASTER.MSISDN.MODIFY')" type="button" (click)="editMsisdnRange(row)" title ="Edit" 
                                    class=" btn btn-xs btn-icon">
                                    <i class="feather icon-edit-2"></i>
                                </button>
                                <button *ngIf="masterService.checkFeatureBoolean('MASTER.MSISDN.DELETE')" type="button" (click)="deleteMsisdnRange(row)" title ="Delete"
                                    class=" btn btn-xs btn-icon text-danger">
                                    <i class="feather icon-trash-2"></i>
                                </button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="d-flex align-items-center mt-3" style="width: 100%;">
              <!-- Left: Items per page dropdown -->
              <div style="min-width: 180px;">
                <select 
                  class="form-select form-select-sm" 
                  [(ngModel)]="element.size" 
                  (change)="onPageChange({ pageIndex: 0, pageSize: element.size })">
                  <option *ngFor="let size of pageSizeOptions" [value]="size">
                    {{size}} items per page
                  </option>
                </select>
              </div>
              <!-- Center: Showing X - Y of Z items -->
              <div style="flex: 1 1 0; text-align: center; min-width: 220px;">
                Showing {{ (element.page * element.size) + 1 }} -
                {{ Math.min((element.page + 1) * element.size, totalElements) }}
                of {{ totalElements }} items
              </div>
              <!-- Right: Pagination arrows -->
              <div style="min-width: 80px;" class="d-flex align-items-center justify-content-end">
                <button
                  class="btn btn-link p-1"
                  [disabled]="element.page === 0"
                  (click)="onPageChange({ pageIndex: element.page - 1, pageSize: element.size })"
                >
                  <i class="feather icon-chevron-left"></i>
                </button>
                <button
                  class="btn btn-link p-1"
                  [disabled]="element.page >= totalPages - 1"
                  (click)="onPageChange({ pageIndex: element.page + 1, pageSize: element.size })"
                >
                  <i class="feather icon-chevron-right"></i>
                </button>
              </div>
            </div>
        </div>
    </div>
</div>
<simple-notifications [options]="notificationOptions"></simple-notifications>